import CryptoJS from "crypto-js";
import { v4 as uuidv4 } from "uuid";


class HmacHelper{

public generateHmacHeaders(
    method: string,
    url: string,
    body: any,
    clientId: string,
    clientSecret: string,
    contextPath: string = "",
    dropContextPath: boolean = false
): Record<string, string> {
    // --- Step 1: Parse and normalize URL ---
    const u = new URL(url);

    let path = u.pathname;
    if (dropContextPath && contextPath && path.startsWith(contextPath)) {
        path = path.substring(contextPath.length);
        if (!path.startsWith("/")) path = "/" + path;
    }

    // --- Step 2: Sort and serialize query parameters ---
    const params: { k: string; v: string }[] = [];
    u.searchParams.forEach((v, k) => params.push({ k, v }));
    params.sort((a, b) => a.k.localeCompare(b.k));
    const query = params.map((p) => `${p.k}=${p.v}`).join("&");

    // --- Step 3: Body hashing ---
    const bodyStr =
        body && Object.keys(body).length > 0
            ? JSON.stringify(body)
            : "";
    const contentSha256 = CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(bodyStr)).toString(
        CryptoJS.enc.Hex
    );

    // --- Step 4: Common headers ---
    const ts = Date.now().toString();
    const nonce = uuidv4();
    const signedHeaders = "host;x-client-id;x-timestamp;x-nonce;content-sha256";
    const hostHdr = u.host;

    // --- Step 5: Canonical string ---
    const canonical = `${method.toUpperCase()}
${path}
query=${query}
host:${hostHdr}
x-client-id:${clientId}
x-timestamp:${ts}
x-nonce:${nonce}
content-sha256:${contentSha256}`;

    // --- Step 6: Signature ---
    const signature = CryptoJS.enc.Base64.stringify(
        CryptoJS.HmacSHA256(canonical, clientSecret)
    );

    // --- Step 7: Build headers ---
    return {
        Host: hostHdr,
        "X-Client-Id": clientId,
        "X-Timestamp": ts,
        "X-Nonce": nonce,
        "X-Signed-Headers": signedHeaders,
        "Content-SHA256": contentSha256,
        "X-Signature": signature,
    };
}
}

export default new HmacHelper();
